import React, { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { events } from '../data/events';
const nextEventPath = `/events/${events[0].slug}`;
const links = [{
  to: '/',
  label: 'Upcoming events'
}, {
  to: '/past-events',
  label: 'Past events'
}];
export function SiteHeader() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  return <header className="sticky top-0 z-40 border-b border-paper-line bg-paper/95 backdrop-blur" data-id="element-194" data-mp="uyirm99vdqw7">
      <div className="mx-auto flex max-w-content items-center justify-between gap-6 px-5 py-4 sm:px-8" data-id="element-195" data-mp="qy8dg9bxbu69">
        <Link to="/" className="flex items-baseline gap-2" onClick={() => setOpen(false)} data-id="element-196" data-mp="14xq5qyofhpkd">
          <span className="font-display text-xl font-bold uppercase tracking-tight text-ink" data-id="element-197" data-mp="zvr1znos0qmw">
            Human <span className="text-signal" data-id="element-198" data-mp="2g9qw2i0xxm28">Planet</span>
          </span>
          <span className="eyebrow text-ink-muted" data-id="element-199" data-mp="2bbfn09igzfl2">Events</span>
        </Link>

        <nav aria-label="Primary" className="hidden items-center gap-8 md:flex" data-id="element-200" data-mp="29kbr5ds6yio0">
          {links.map(link => <NavLink key={link.to} to={link.to} end={link.to === '/'} className={({
          isActive
        }) => ['text-sm transition-colors', isActive ? 'text-signal' : 'text-ink-muted hover:text-ink'].join(' ')} data-id="element-201" data-mp="2ehvhhc25ylwb">
              {link.label}
            </NavLink>)}
          <a href="https://human-planet.com" className="text-sm text-ink-muted transition-colors hover:text-ink" data-id="element-202" data-mp="1vsf3pn1gwwxy">
            human-planet.com
          </a>
          <Link to={nextEventPath} className="rounded-full bg-signal px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-signal-deep" data-id="element-203" data-mp="20pnmnpufx509">
            Register to attend
          </Link>
        </nav>

        <button type="button" className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-paper-line text-ink md:hidden" onClick={() => setOpen(prev => !prev)} aria-expanded={open} aria-label={open ? 'Close menu' : 'Open menu'} data-id="element-204" data-mp="1d0w3fnytvwzm">
          {open ? <XIcon className="h-5 w-5" data-id="element-205" data-mp="1eq9kg1vsbpd5" /> : <MenuIcon className="h-5 w-5" data-id="element-206" data-mp="19ry9toxo1atv" />}
        </button>
      </div>

      {open && <nav aria-label="Primary mobile" className="border-t border-paper-line bg-paper md:hidden" data-id="element-207" data-mp="19uau48qwbxa3">
          <ul className="mx-auto max-w-content px-5 py-2 sm:px-8" data-id="element-208" data-mp="h3al1jdpk3bk">
            {links.map(link => <li key={link.to} className="border-b border-paper-line" data-id="element-209" data-mp="w0jt5or8dlpz">
                <Link to={link.to} onClick={() => setOpen(false)} className={['block py-3 text-sm', location.pathname === link.to ? 'text-signal' : 'text-ink'].join(' ')} data-id="element-210" data-mp="vygs89oji86h">
                  {link.label}
                </Link>
              </li>)}
            <li className="py-4" data-id="element-211" data-mp="29ytnksn84i6u">
              <Link to={nextEventPath} onClick={() => setOpen(false)} className="block rounded-full bg-signal px-5 py-3 text-center text-sm font-medium text-white" data-id="element-212" data-mp="2ez7ycig7m68k">
                Register to attend
              </Link>
            </li>
          </ul>
        </nav>}
    </header>;
}